import { type Participant } from '@databases/presence';

import { IdentityKind } from '@canvas/model/identity';

export const getAiFieldStreamingParticipants = ({
  participants,
  shouldExcludeAiAgent
}: {
  participants: Participant[];
  shouldExcludeAiAgent: boolean;
}): Participant[] =>
  shouldExcludeAiAgent
    ? participants.filter(({ identity }) => identity.type !== IdentityKind.AiAgent)
    : participants;
